import classNames from 'classnames';
import React from 'react';
const Lazyimg = (props) => {
    return (React.createElement("img", { src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", "data-src": props.src, className: classNames('lazyload', props.className, { 'not-draggable': !props.draggable }), alt: props.alt, width: props === null || props === void 0 ? void 0 : props.width, height: props === null || props === void 0 ? void 0 : props.height, draggable: props.draggable, "aria-hidden": (props === null || props === void 0 ? void 0 : props.ariaHidden) ? true : false }));
};
export default Lazyimg;
